"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Types = void 0;
var Types = {
  Boolean: 'Boolean',
  Double: 'Double',
  Int16: 'Int16',
  Int32: 'Int32',
  Int32Positive: 'Int32Positive',
  Int64: 'Int64',
  Single: 'Single',
  String: 'String',
  Time: 'Time'
};
exports.Types = Types;